module.exports = __webpack_public_path__ + "img/成都.027b31fe.jpg";